import { ReactNode } from 'react';
import { Typography } from '@mui/material';

import { useTitleStyles } from './TitleStyles';

export interface TitleProps {
  children?: string | number;
  className?: string;
  classNameContainer?: string;
  csvButton?: ReactNode;
}

export const Title = ({
  className,
  classNameContainer,
  children,
  csvButton,
}: TitleProps) => {
  const { classes, cx } = useTitleStyles();

  return (
    <div className={cx(classes.titleContainer, classNameContainer)}>
      <Typography className={cx(classes.title, className)} variant="subtitle2">
        {children}
      </Typography>

      {Boolean(csvButton) && csvButton}
    </div>
  );
};
